import {
  BLOCKED_TYPE_TEXT,
  BlockedCourseChipGroup,
  BlocklistProctorInformationFields,
  EmployeeInformationFields,
} from '@exam-center/blocked-user-management';
import { BlockedRecordBlockedScope } from '@exam-center/graphql';
import { Divider, Flex, PaperSection, SectionTitle, Text } from '@shared/components';
import { formatDate } from '@shared/utils';

import { useBlockedRecordDetails } from '../../providers';

export default function BlockedStaffReadonlyDetails() {
  const { blockedRecord } = useBlockedRecordDetails();

  const enforcementEndDate = blockedRecord.metadata.enforcementEndDate;
  const blockedCourses = blockedRecord.blockedRecordCourses.map((course) => ({
    code: course.examCourse?.code ?? '',
    name: course.examCourse?.name ?? '',
  }));
  const isBlockedAllScope = blockedRecord.blockedScope === BlockedRecordBlockedScope.AllScope;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
      <PaperSection title='ข้อมูลการระงับสิทธิ์สอบ'>
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
        >
          <SectionTitle title='Person Information' />
          <EmployeeInformationFields
            fields={{
              blockedType: { mode: 'view', value: BLOCKED_TYPE_TEXT[blockedRecord.blockedType] },
              position: { mode: 'view', value: blockedRecord.metadata.position || '-' },
              department: { mode: 'view', value: blockedRecord.metadata.department || '-' },
            }}
            visibleFields={{
              position: true,
              department: true,
            }}
          />
        </Flex>
        <Divider />
        <BlocklistProctorInformationFields
          fields={{
            startedAt: { mode: 'view', value: formatDate(blockedRecord.blockedAt) },
            blockedCourseType: {
              mode: 'view',
              value: isBlockedAllScope ? (
                <Text>ระงับสิทธิ์ทุกหลักสูตร</Text>
              ) : (
                <BlockedCourseChipGroup examCourseInfos={blockedCourses} />
              ),
              slotProps: {
                icon: { sx: { display: 'none' } },
              },
            },
            endedAt: {
              mode: 'view',
              value: formatDate(enforcementEndDate),
            },
            remark: { mode: 'view', value: blockedRecord.blockedReason ?? '-' },
          }}
          options={{
            shouldDisplayEndedAtAsDate: !!enforcementEndDate,
            shouldDisplayBlockedCourseSelection: false,
          }}
          slots={{
            endedAtDateEndAdornment: enforcementEndDate ? (
              <Text sx={(theme) => ({ pb: theme.spacing(3) })}>
                (วันที่สิ้นสุดระงับสิทธิ์: {formatDate(blockedRecord.blockedUntil)})
              </Text>
            ) : (
              <Text sx={(theme) => ({ pb: theme.spacing(3) })}>ไม่มีกำหนด</Text>
            ),
          }}
        />
      </PaperSection>
    </Flex>
  );
}
